var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-primary tone-100 box d-flex justify-center align-center"},[_c('font-awesome-icon',{staticClass:"brand-primary--text text--tone-400",attrs:{"icon":_vm.icon,"size":"xl"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }